const BB_SELECTED_OPTIONS = 'bb_selected_options'

class BundleBuilderHandler {
	constructor() {
		this.options = {}
		this.selectedOptions = {}
		this.currentProduct = null
	}

	// ------------------------------------------------------------ getters
	get bundleProducts() {
		return window.bundleProducts
	}

	get excludingTags() {
		return window.bundleSettings?.excluding_tags
	}

	get groupByQuantity() {
		return window.bundleSettings?.group_by_quantity
	}

	get bundleDiscount() {
		return window?.bundleSettings?.bundle_discount || 3
	}

	get bodyEl() {
		return document.querySelector('body')
	}

	get bundleCategoriesEls() {
		return document.querySelectorAll('#bundle-builder li.grid .li-a')
	}

	get modalBundleItemEl() {
		return document.querySelector('#modal-bundle-item')
	}

	get swatchesWrapperEl() {
		return document.querySelector('#swatches-wrapper')
	}

	get bundleItemsEl() {
		return document.querySelector('#bundle-items')
	}

	get productOptionsLength() {
		return this.currentProduct.options?.length || Number(this.currentProduct.option_size) || 0
	}

	// ------------------------------------------------------------ setters
	set setCurrentProduct(product) {
		this.currentProduct = product
	}

	// ------------------------------------------------------------ methods
	init() {
		this.bundleCategoriesListeners()
		this.modalListeners()
		this.handleBundleItems()
		this.handleUrlParams()

		window.FctApp.cart.refreshCart()
	}

	handleBundleItems() {
		const self = this

		document.addEventListener('updateCart', function(event) {
			const cartData = event.detail.cartData

			const cartItemsFiltered = cartData.items.filter(item => {
				const cartProduct = document.querySelector(`[data-cart-product-id="${item.product_id}"]`)

				if (cartProduct) {
					const tags = JSON.parse(cartProduct.getAttribute('data-cart-product-tags'))
					return !self.excludingTags.some(tag => tags.includes(tag?.trim()))
				}
			})

			function expandArrayByQuantity(inputArray) {
				return inputArray.flatMap((item, index) => {
					const { quantity, ...rest } = item
					return Array.from({ length: quantity }, () => ({
						...rest,
						quantity: 1,
						total_quantity: quantity,
						original_index: index
					}))
				})
			}

			const finalArray = self.groupByQuantity ? cartItemsFiltered : expandArrayByQuantity(cartItemsFiltered)
			console.log(finalArray)

			const module = finalArray.length % 5 || 5
			const finalModule = module === 5 && finalArray.length !== 5 ? 0 : module

			let bundleItemsHTML = ''

			finalArray.forEach((item, index) => {

				let show = finalArray.length > 5 ? finalModule >= index + 1 : true

				const bundleItemHTML = `
						<a href="/products/${item.handle}"
							class="bundle-item is-product${show ? '' : ' hidden'}"
							data-variant-id="${item.id}"
						>
							<span
								class="bundle-close ${self.groupByQuantity ? 'cart-delete' : 'minus-control'}"
								data-id="${item.id}"
								data-total-quantity="${item.total_quantity || item.quantity}"
								data-selling-id="${item.selling_plan_allocation?.selling_plan.id || ''}"
								data-index="${item.original_index + 1  || index + 1}"
							>
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<circle cx="10" cy="10" r="9" fill="white" stroke="#DCDCDC" stroke-width="2"/>
									<path d="M10.7043 9.99957L12.8522 7.85634C12.9463 7.76227 12.9991 7.63467 12.9991 7.50163C12.9991 7.36859 12.9463 7.241 12.8522 7.14692C12.7582 7.05285 12.6306 7 12.4976 7C12.3646 7 12.237 7.05285 12.1429 7.14692L10 9.29515L7.85707 7.14692C7.76301 7.05285 7.63544 7 7.50241 7C7.36939 7 7.24182 7.05285 7.14776 7.14692C7.0537 7.241 7.00085 7.36859 7.00085 7.50163C7.00085 7.63467 7.0537 7.76227 7.14776 7.85634L9.29568 9.99957L7.14776 12.1428C7.10094 12.1893 7.06378 12.2445 7.03842 12.3054C7.01306 12.3663 7 12.4316 7 12.4975C7 12.5635 7.01306 12.6288 7.03842 12.6896C7.06378 12.7505 7.10094 12.8058 7.14776 12.8522C7.19419 12.899 7.24944 12.9362 7.31031 12.9616C7.37118 12.9869 7.43647 13 7.50241 13C7.56836 13 7.63365 12.9869 7.69452 12.9616C7.75539 12.9362 7.81063 12.899 7.85707 12.8522L10 10.704L12.1429 12.8522C12.1894 12.899 12.2446 12.9362 12.3055 12.9616C12.3664 12.9869 12.4316 13 12.4976 13C12.5635 13 12.6288 12.9869 12.6897 12.9616C12.7506 12.9362 12.8058 12.899 12.8522 12.8522C12.8991 12.8058 12.9362 12.7505 12.9616 12.6896C12.9869 12.6288 13 12.5635 13 12.4975C13 12.4316 12.9869 12.3663 12.9616 12.3054C12.9362 12.2445 12.8991 12.1893 12.8522 12.1428L10.7043 9.99957Z" fill="black"/>
								</svg>
							</span>
	
							<div class="bundle-inner">
								<img src="${item.image}" alt="${item.product_title}">
	
								${self.groupByQuantity ? `<span class="bundle-items-quantity">${item.quantity}</span>` : ''}
							</div>
						 </a>
					`

				bundleItemsHTML = `${bundleItemsHTML}${bundleItemHTML}`
			})


			self.bundleItemsEl.innerHTML = bundleItemsHTML

			renderQuantityThresholdBar()
			renderPlaceholder(finalModule)
			renderShowAllButton(finalArray.length)
			self.renderBundleBuilderThresholdBar(finalArray)
		})

		function renderQuantityThresholdBar() {
			const quantityThresholdBarEl =
				document.querySelector('#cart-form .quantity-threshold-bar-wrapper') ||
				document.querySelector('.empty-cart-content .quantity-threshold-bar-wrapper')

			if (!quantityThresholdBarEl) return

			const quantityThresholdBarBundleWrapperEl = document.querySelector('#quantity-threshold-bar-bundle-wrapper')
			const quantityThresholdBarModalBundleWrapperEl = document.querySelector('#quantity-threshold-bar-bundle-modal-wrapper')

			if (quantityThresholdBarBundleWrapperEl) quantityThresholdBarBundleWrapperEl.innerHTML = quantityThresholdBarEl.innerHTML
			if (quantityThresholdBarModalBundleWrapperEl) quantityThresholdBarModalBundleWrapperEl.innerHTML = quantityThresholdBarEl.innerHTML
		}

		function renderPlaceholder(module = 0) {
			const bundleItemIsProductEls = self.bundleItemsEl.querySelectorAll('.bundle-item.is-product')
			let placeholdersHTML = ''

			for (let i = 1; i <= 5 - module ; i++) {
				const placeholderHTML = `
					 <a href="#" class="bundle-item is-placeholder">
						 <div class="bundle-inner">
							<span>${bundleItemIsProductEls.length + i}</span>
						</div>
					</a>
				`

				placeholdersHTML = `${placeholdersHTML}${placeholderHTML}`
			}

			self.bundleItemsEl.innerHTML = `${self.bundleItemsEl.innerHTML}${placeholdersHTML}`
		}

		function renderShowAllButton(count) {
			const li = document.querySelector('.li-items')

			if (count > 5) {
				li.classList.add('collapsed')

				const showAllButtonsEl = document.querySelector('#show-all')
				const isProductHiddenEls = document.querySelectorAll('.bundle-item.is-product.hidden')

				const hiddenItemsCount = showAllButtonsEl.querySelector('.hidden-items-count')
				hiddenItemsCount.innerText = isProductHiddenEls.length

				const lastIsProductHiddenEls = isProductHiddenEls[isProductHiddenEls.length - 1]
				const lastIsProductHiddenImageEls = lastIsProductHiddenEls.querySelector('img')
				const showAllButtonsImageEl = showAllButtonsEl.querySelector('img')

				showAllButtonsImageEl.src = lastIsProductHiddenImageEls.src

				showAllButtonsEl.addEventListener('click', () => {
					li.classList.remove('collapsed')
					li.classList.add('expanded')




					if (self.isMobile()) self.handleShowModalBundleItem(false)
				})

			} else {
				li.classList.remove('collapsed')
				li.classList.remove('expanded')
			}
		}

		function handleHiddenItemsBtn() {
			const li = document.querySelector('.li-items')

			const hiddenItemsEl = document.querySelector('#hidden-items')

			hiddenItemsEl.addEventListener('click', () =>{
				li.classList.add('collapsed')
				li.classList.remove('expanded')
			})
		}

		handleHiddenItemsBtn()
	}

	bundleCategoriesListeners() {
		this.bundleCategoriesEls.forEach(bundleCategory => {
			bundleCategory.addEventListener('click', (e) => this.handleBundleCategoryClick(e))
		})
	}

	modalListeners() {
		const self = this

		const closeEl = this.modalBundleItemEl.querySelector('#modal-bundle-item-close')
		closeEl.addEventListener('click', () => this.handleShowModalBundleItem(false))

		const addButtonEl = this.modalBundleItemEl.querySelector('#add-button')
		addButtonEl.addEventListener('click', () => this.handleAddButton())

		this.modalBundleItemEl.addEventListener('click', function(event) { // detecting a modal outside click and closing it
			const modalEL = self.modalBundleItemEl.querySelector('.modal-bundle-item-inner')
			if (!modalEL.contains(event.target)) self.handleShowModalBundleItem(false)
		})

		document.addEventListener('addToCartLoading', function(event) {
			const loading = event.detail.loading

			self.modalBundleItemEl.querySelector('#add-button-wrapper').classList[loading ? 'add' : 'remove']('is-loading')

			if (!loading) {
				self.modalBundleItemEl.querySelector('#add-button-wrapper #add-button').textContent = 'ADDED!'

				setTimeout(() => {
					self.modalBundleItemEl.querySelector('#add-button-wrapper #add-button').textContent = 'ADD TO CART'
				}, 2000)
			}
		})
	}

	handleBundleCategoryClick(e) {
		e.preventDefault()
		this.renderModalContent(e.currentTarget)
	}

	renderModalContent(currentTarget, swatchClick = false) {
		const productId = currentTarget.getAttribute('data-product-id')
		const swatchesStr = currentTarget.getAttribute('data-swatches')
		const swatches = swatchesStr ? JSON.parse(swatchesStr) : ''

		this.setCurrentProduct = this.bundleProducts.find(bundleProduct => bundleProduct?.id === Number(productId))

		if (this.currentProduct) {
			this.renderSlider()
			this.renderTitle()
			this.renderPrices()
			// this.renderSubscriptionFrequency()
			this.renderOptions()
			this.handleViewFullDetails()

			if (!swatchClick) {
				if (swatches) this.renderSwatches(swatches)
				this.handleShowModalBundleItem(true)
				this.adjustModalHeight()
			}

			this.handleCurrentSwatch()
			this.handleOptionsFromLocalStorage()

			const modalEL = this.modalBundleItemEl.querySelector('.modal-bundle-item-inner')
			if (modalEL) modalEL.scrollTop = 0
		}
	}

	handleCurrentSwatch() {
		const swatchesEls = this.swatchesWrapperEl.querySelectorAll('.swatch')
		const currentSwatch = this.swatchesWrapperEl.querySelector(`.swatch[data-handle="${this.currentProduct.handle}"]`)
		const swatchesBlocksEls = this.swatchesWrapperEl.querySelectorAll('.swatches-block')

		if (swatchesEls.length && currentSwatch) {
			swatchesEls.forEach(swatchEl => swatchEl.classList.remove('current-swatch'))
			currentSwatch.classList.add('current-swatch')

			swatchesBlocksEls.forEach(swatchesBlock => {
				const colorNameEl = swatchesBlock.querySelector('label span.color-name')
				colorNameEl.innerText = swatchesBlock.contains(currentSwatch) ? currentSwatch.getAttribute('data-value') : ''
			})
		}
	}

	adjustModalHeight() {
		const modalEL = this.modalBundleItemEl.querySelector('.modal-bundle-item-inner')

		if (!modalEL) return

		const summerHeight = this.isMobile() ? 183 : 122 // 173 = 163px bundle mobile summer height + 10 margin top and + 10 margin bottom / 122 = 102px bundle summer height + 10 margin top and + 10 margin bottom

		const contentHeight = modalEL.scrollHeight
		const maxHeight = window.innerHeight - summerHeight

		modalEL.style.height = contentHeight > maxHeight ? maxHeight + 'px' : contentHeight + 'px'
	}

	renderSlider() {
		if (this.currentProduct?.images) {
			let sliderHTML = ''

			this.currentProduct.images.forEach(imgUrl => {
				const sliderItemHTML = `
					<img src="${imgUrl}" alt="" class="slider-item">
				`

				sliderHTML = `${sliderHTML}${sliderItemHTML}`
			})

			this.modalBundleItemEl.querySelector('#modal-bundle-item-slider').innerHTML = sliderHTML
		}
	}

	renderTitle() {
		this.modalBundleItemEl.querySelector('#modal-bundle-item-title').innerHTML = `<a href="/products/${this.currentProduct.handle}">${this.currentProduct.title}</a>`
	}

	renderPrices() {
		const initComparePrice = this.currentProduct.compare_at_price > this.currentProduct.price
			? this.currentProduct.compare_at_price
			: this.currentProduct.price
		const initPrice = this.currentProduct.price / 100 - window?.bundleSettings?.bundle_discount

		this.modalBundleItemEl.querySelector('#modal-bundle-item-prices').innerHTML = `
			<span class="line-through">$${(initComparePrice / 100).toFixed(2)}</span>
			<span class="sale">$${initPrice.toFixed(2)}</span>
		`
	}

	renderOptions() {
		const { hideShort, hideTall } = this.getHideFlags({
			product: this.currentProduct,
			settings: window.ShopData?.settings,
			marketHandle: window.ShopData?.market
		})


		const optionsWithValues = this.currentProduct.options_with_values
		const productOptions = this.modalBundleItemEl.querySelector(`#product-options-wrapper`)

		let optionsHTML = ''

		optionsWithValues?.forEach(product_option => {
			const hideLengthBlock = product_option.name === 'Length' && hideShort && hideTall

			let optionsBlockHTML = `
			<div class="options-block"${hideLengthBlock ? ' style="display: none"' : '' }>
				<label for="${product_option.name}" class="name-options">${product_option.name}:
					<span class="selected-option" data-selected-postion="${product_option.position}"></span>
				</label>
				
				<div class="options option-count-${product_option.values?.length}">
				
					${product_option.values?.map(value => {
						if ((value === 'Short' && hideShort) || (value === 'Tall' && hideTall)) return ''
				
						return `
							<div class="option">
								<input
									id="option-${product_option.name.replace(/\s+/g, '-').toLowerCase()}-${value.toLowerCase()}-modal-bundle-item"
									class="input-option"
									autocomplete="off"
									data-option-position="${product_option.position}"
									type="radio"
									name="${product_option.name.toLowerCase()}-quick-shop"
									value="${value}"
								>
							
								<label class="label-option" for="option-${product_option.name.replace(/\s+/g, '-').toLowerCase()}-${value.toLowerCase()}-modal-bundle-item">${this.sizeSimplify(value)}</label>
							</div>
						`
					}).join('')}
					
				</div>
			</div>
		`

			optionsHTML = `${optionsHTML}${optionsBlockHTML}`
		})

		productOptions.innerHTML = optionsHTML

		this.optionsAddEventListener()

		if (hideShort && hideTall) {
			const lengthRegularEl = document.querySelector('#option-length-regular-modal-bundle-item')

			if (lengthRegularEl) {
				lengthRegularEl.checked = true
				lengthRegularEl.dispatchEvent(new Event('change', { bubbles: true }))
			}
		}
	}

	renderSwatches(swatches) {
		let optionsHTML = ''

		swatches.forEach(item => {

			let optionsBlockHTML = `
						<div class="swatches-block">
							<label>${item.swatch_name}: <span class="color-name"></span></label>
							
							<div class="swatches">
							
								${item.colour_list?.split(',')?.map(value => {
									const swatch = value.split('_') // EXAMPLE: black_#212223_black-crew-neck
									const swatchObj = {
										colorName: swatch[0],
										color: swatch[1],
										handle: swatch[2],
									}
					
									const initProduct = this.bundleProducts.find(bundleProduct => bundleProduct?.handle === swatchObj?.handle)
					
									if (initProduct) {
										return `
											<div
												data-product-id="${initProduct.id}"
												data-handle="${swatchObj.handle}"
												data-value="${swatchObj.colorName}"
												class="swatch"
											>
												<span style="${this.handleSwatchStyle(swatchObj.color)}"></span>
											</div>
										`
									}
					
								}).join('')}
								
							</div>
						</div>
					`

			optionsHTML = `${optionsHTML}${optionsBlockHTML}`
		})

		this.swatchesWrapperEl.innerHTML = optionsHTML
		this.swatchesAddEventListener()
	}

	renderSubscriptionFrequency() {
		const hasSellingPlans = this.currentProduct.selling_plan_groups?.length > 0
		const subscriptionFrequencyEl = this.modalBundleItemEl.querySelector(`#subscription-frequency-wrapper`)

		if (hasSellingPlans) {
			const isSubOnly = this.currentProduct.requires_selling_plan
			const currentPlanDiscount = this.currentProduct?.selling_plan_groups[0]?.selling_plans[0]?.price_adjustments[0]?.value

			subscriptionFrequencyEl.innerHTML = `
				<div id="subscription_frequancy" class="subscription_frequancy">
					<label class="subscription_frequancy_label">Frequency:</label>

					<div class="subscription_frequancy_items">
						${isSubOnly ? '' : `
							<div class="subscription_frequancy_item" data-sub-type="onetime">
								<div class="subscription_frequancy_trigger is-Active">
									<span class="radio__circle"></span> 
									<input type="radio" checked name="subscription-radio" class="radio__input" value="onetime">
									<span class="subscription_frequancy_triggerText">One-Time Purchase</span>
								</div>
							</div>
						`}

						<div class="subscription_frequancy_item" data-sub-type="subscription">
							<div class="subscription_frequancy_trigger${isSubOnly ? ' is-Active' : ''}">
								<span class="radio__circle"></span>
								<input type="radio" ${isSubOnly ? 'checked' : ''} name="subscription-radio" class="radio__input" value="subscription">
								<div class="subscription_frequancy_textWrapper${isSubOnly ? ' subscription-only' : ''}">
								    <span class="subscription_frequancy_triggerText">Subscribe and </span> 
								    <span class="subscription_frequancy_triggerHighlight">${isSubOnly ? 'Get Free Shipping' : `Save ${currentPlanDiscount}% + Get Free Shipping`}</span>
								</div>
							</div>
							
							<div class="frequency_content${isSubOnly ? '' : ' hidden'}">
								<div class="frequency_buttons_wrapper">
									${this.currentProduct?.selling_plan_groups[0]?.selling_plans?.map((plan, index) => {
										return `
												<span
													data-selling-plan-name="${plan.name}"
													data-selling-plan-id="${plan.id}"
													class="frequency_button${index === 0 ? ' is-Active' : ''}"
												>
													${plan.name.replace('Delivery every ', '')}
												</span>
											`
										}).join('')}
										</div>
									</div>
							</div>
						</div>
					</div>
				</div>
			`

			this.subscriptionFrequencyAddEventListener(isSubOnly)
		} else subscriptionFrequencyEl.innerHTML = ''
	}

	handleViewFullDetails() {
		this.modalBundleItemEl.querySelector('#view-full-details a').href = `/products/${this.currentProduct.handle}`
	}

	optionsAddEventListener() {
		this.modalBundleItemEl.querySelectorAll('.input-option')?.forEach(option => {
			option.addEventListener('change', e => {
				this.setOption(e.currentTarget)
				this.setOptionsInLocalStorage(e.currentTarget)
			})
		})
	}

	swatchesAddEventListener() {
		this.modalBundleItemEl.querySelectorAll('.swatch')?.forEach(swatch => {
			swatch.addEventListener('click', e => {
				this.renderModalContent(e.currentTarget, true)
			})
		})
	}

	subscriptionFrequencyAddEventListener(isSubOnly) {
		if (!isSubOnly) {
			const oneTimeTriggerEl = this.modalBundleItemEl.querySelector('#subscription_frequancy div[data-sub-type=onetime] .subscription_frequancy_trigger')
			const subTriggerEl = this.modalBundleItemEl.querySelector('#subscription_frequancy div[data-sub-type=subscription] .subscription_frequancy_trigger')
			const subContentEl = this.modalBundleItemEl.querySelector('#subscription_frequancy .frequency_content')

			this.modalBundleItemEl.querySelectorAll('#subscription_frequancy .radio__input')?.forEach(item => {
				item.addEventListener('change', e => {
					oneTimeTriggerEl.classList.toggle('is-Active')
					subTriggerEl.classList.toggle('is-Active')
					subContentEl.classList.toggle('hidden')
				})
			})
		}

		const frequencyButtonsEls = this.modalBundleItemEl.querySelectorAll('#subscription_frequancy .frequency_content .frequency_button')

		frequencyButtonsEls?.forEach(frequencyButton => {
			frequencyButton.addEventListener('click', e => {
				frequencyButtonsEls.forEach(b => b.classList.remove('is-Active'))
				e.currentTarget.classList.add('is-Active')
			})
		})
	}

	setOption(currentTarget) {
		const value = currentTarget.value
		const position = currentTarget.getAttribute('data-option-position')

		const selectedSpan = this.modalBundleItemEl.querySelector(`span[data-selected-postion="${position}"]`)
		if (selectedSpan) selectedSpan.innerText = value

		this.options[`option${position}`] = value

		this.checkSoldout()
		this.checkSwatchAvailable()
		this.checkSelectedAllOptions()
	}

	setOptionsInLocalStorage(currentTarget) {
		const optionName = currentTarget.getAttribute('name')
		const value = currentTarget.value

		const initOption = {
			optionName,
			value
		}

		this.selectedOptions[initOption.optionName] = value

		let selectedProductOptions = this.getBBSelectedOptions()

		if (selectedProductOptions) {
			const modifyProperty = (arr, optionName, value) => {
				const targetObj = arr.find(obj => obj.optionName === optionName)

				if (targetObj) targetObj.value = value
				else selectedProductOptions.push(initOption)
			}

			modifyProperty(selectedProductOptions, initOption.optionName, initOption.value)
		} else selectedProductOptions = [initOption]

		this.setBBSelectedOptions(selectedProductOptions)
	}

	handleOptionsFromLocalStorage() {
		const selectedProductOptions = this.getBBSelectedOptions()

		if (selectedProductOptions) {
			selectedProductOptions.forEach(o => this.setOptionFromLocalStorage(o))
		} else {
			this.setOptionFromLocalStorage({ optionName: 'length', value: 'Regular' }) // default value
		}
	}

	setOptionFromLocalStorage(productVariant) {
		const value = productVariant.value
		const optionName = productVariant.optionName
		const input = document.querySelector(`input[value="${value}"][name="${optionName}"]`)

		if (input) {
			const position = input.getAttribute('data-option-position')
			input.checked = true

			const selectedSpan = this.modalBundleItemEl.querySelector(`span[data-selected-postion="${position}"]`)
			if (selectedSpan) selectedSpan.innerText = value

			this.options[`option${position}`] = value;
			this.selectedOptions[optionName] = value;

			this.checkSwatchAvailable()
			this.checkSoldout()
			this.checkSelectedAllOptions()
		}
	}

	checkSoldout() {
		this.modalBundleItemEl.querySelectorAll('.input-option')?.forEach(option => {
			const initOptions = { ...this.options }

			const value = option.value
			const position = option.getAttribute('data-option-position')

			initOptions[`option${position}`] = value

			const variantFiltered = this.productVariantsHandler(initOptions, this.currentProduct, 'filter')

			if (variantFiltered.length) {
				const available = variantFiltered.some(e => e.available)

				if (available) {
					option.parentElement.classList.remove('soldout')
					option.parentElement.classList.add('available')
				} else {
					option.parentElement.classList.remove('available')
					option.parentElement.classList.add('soldout')
				}
			}
		})
	}

	checkSwatchAvailable() {
		this.bundleProducts?.forEach(product => {
			const initOptions = { ...this.options }
			const variantFiltered = this.productVariantsHandler(initOptions, product, 'filter')

			if (variantFiltered) {
				const available = variantFiltered.some(e => e.available)
				const swatchEl = this.modalBundleItemEl.querySelector(`.swatch[data-handle="${product.handle}"]`)

				if (!swatchEl) return

				swatchEl.classList[available ? 'remove' : 'add']('swatch-not-available')
			}
		})

		this.checkSwatchAvailableForBlock()
	}

	checkSwatchAvailableForBlock() {
		const swatchesEls = document.querySelectorAll('#swatches-wrapper .swatches-block')

		if (!swatchesEls.length) return

		swatchesEls.forEach(s => {
			const swatchEls = s.querySelectorAll('.swatch')
			const swatchSizeNotAvailableEls = s.querySelectorAll('.swatch.swatch-not-available')

			s.style.display = swatchEls.length === swatchSizeNotAvailableEls.length ? 'none' : 'block'
		})
	}


	checkSelectedAllOptions() {
		const optionsLength = Object.keys(this.options).length

		if (this.productOptionsLength <= optionsLength) this.getVariant()
	}

	getVariant() {
		const variant = this.productVariantsHandler(this.options, this.currentProduct, 'find')

		this.handleButtons(variant)
	}

	handleSwatchStyle(color = '') {
		if (!color.includes('-')) return `background-color: ${color};`

		const parts = color.split('-')
		const type = parts[0]

		switch (type) {
			case 'striped':
				let stripedAngle =  parts[1]
				let stripedColor1 =  parts[2]
				let stripedColor2 =  parts[3]

				return `
					background: repeating-linear-gradient(${stripedAngle}, ${stripedColor1}, ${stripedColor1} 3px, ${stripedColor2} 3px, ${stripedColor2} 6px);
					background-size: 5px;
				  `

			case 'gingham':
				let ginghamColor1 =  parts[1]
				let ginghamColor2 =  parts[2]

				return `
					background-image:
					  repeating-linear-gradient(0deg, ${ginghamColor1}80 0 4px, transparent 4px 8px),
					  repeating-linear-gradient(90deg, ${ginghamColor2}80 0 4px, transparent 4px 8px);
					background-color: ${ginghamColor2};
				  `

			default:
				return `background-color: ${color};`
		}
	}

	handleButtons(variant = {}) {
		const addButtonEl = this.modalBundleItemEl.querySelector('#add-button')

		if (variant.available) {
			addButtonEl.innerText = 'ADD TO CART'
			addButtonEl.removeAttribute('disabled')
		} else {
			addButtonEl.innerText = 'SELECT OPTIONS'
			addButtonEl.setAttribute('disabled', 'disabled')
		}
	}

	handleAddButton() {
		const variant = this.productVariantsHandler(this.options, this.currentProduct, 'find')
		const qtyVal = this.modalBundleItemEl.querySelector('#qty')?.value || 1

		if (variant) {
			addtocart(variant.id, qtyVal, '', '', true, this.getSellingPlanId(), true)// custom.js method
		}
	}

	getSellingPlanId() {
		const value = this.modalBundleItemEl.querySelector('#subscription_frequancy .radio__input:checked')?.value
		const sellingPlanId = this.modalBundleItemEl.querySelector('div[data-sub-type=subscription] .is-Active.frequency_button')?.getAttribute('data-selling-plan-id')

		return value === 'subscription' && sellingPlanId ? sellingPlanId : ''
	}

	productVariantsHandler(initOptions, product, method) {
		const variants = product.variants

		if (!initOptions || !variants) return false

		return variants[method](variant => {
			// checking for out of stock when if first option is not selected
			const optionsKeys = Object.keys(initOptions)

			if (optionsKeys.length === 1 || this.productOptionsLength === 1) {
				const optionKey = optionsKeys[0]
				return variant[optionKey] === initOptions[optionKey]
			}

			let result = false

			if (initOptions['option1']) {
				result = this.handleVariant(variant.option1) === initOptions['option1']
			}

			if (initOptions['option1'] && initOptions['option2']) {
				result =
					this.handleVariant(variant.option1) === initOptions['option1'] &&
					this.handleVariant(variant.option2) === initOptions['option2']
			}

			if (initOptions['option1'] && initOptions['option2'] && initOptions['option3']) {
				result =
					this.handleVariant(variant.option1) === initOptions['option1'] &&
					this.handleVariant(variant.option2) === initOptions['option2'] &&
					this.handleVariant(variant.option3) === initOptions['option3']
			}

			return result
		})
	}

	handleShowModalBundleItem(show = false) {
		this.bodyEl.classList[show ? 'add' : 'remove']('body-modal-bundle-item-showing')
		this.modalBundleItemEl.classList[show ? 'add' : 'remove']('show')
	}


	renderBundleBuilderThresholdBar(items = []) {
		const itemsCount = this.calculateCartCount(items)
		const BBThresholdBarEl = document.querySelector('#bundle-builder-threshold-bar')

		if (!BBThresholdBarEl) return

		const isUnlocked = itemsCount >= 5
		BBThresholdBarEl.querySelector('.bundle-builder-threshold-bar').classList[isUnlocked ? 'add' : 'remove']('unlocked')


		// handle an unlocked message
		const unlockedMessageEl = BBThresholdBarEl.querySelector('.bundle-builder-threshold-bar__unlockedMessage')

		if (isUnlocked) {
			unlockedMessageEl.innerHTML = `YOU HAVE UNLOCKED <span>$${itemsCount * this.bundleDiscount} OFF</span>`
			unlockedMessageEl.style.display = 'block'
		} else {
			unlockedMessageEl.style.display = 'none'
		}


		// handle a threshold bar message
		const thresholdBarMessageEl = BBThresholdBarEl.querySelector('.bundle-builder-threshold-bar__message')

		if (isUnlocked) {
			thresholdBarMessageEl.innerHTML = `ADD MORE TO <span>SAVE MORE</span>`
		} else {
			thresholdBarMessageEl.innerHTML = `YOU ARE ONLY <span>${5 - itemsCount} ${5 - itemsCount === 1 ? 'item' : 'items'}</span> AWAY FROM <span>$${5 * this.bundleDiscount} OFF</span>`
		}

		// handle progress bar width
		const progressBarEl = BBThresholdBarEl.querySelector('.bundle-builder-threshold-bar__progressBar')
		if (progressBarEl) progressBarEl.style.width = `${itemsCount * 20}%`

		// show bundle builder threshold bar
		BBThresholdBarEl.style.visibility = 'visible'

		const BBThresholdBarModalWrapperEl = document.querySelector('#bundle-builder-threshold-bar-modal-wrapper')
		if (BBThresholdBarModalWrapperEl) BBThresholdBarModalWrapperEl.innerHTML = BBThresholdBarEl.innerHTML
	}

	calculateCartCount(items = []) {
		return items.reduce((total, item) => {
			const cartProduct = document.querySelector(`[data-cart-product-id="${item.product_id}"]`)
			if (cartProduct) {
				const tags = JSON.parse(cartProduct.getAttribute('data-cart-product-tags'))

				if (!this.excludingTags.some(tag => tags.includes(tag?.trim()))) {
					return total + item.quantity
				}
			}

			return total
		}, 0)
	}

	getBBSelectedOptions() {
		return JSON.parse(localStorage.getItem(BB_SELECTED_OPTIONS))
	}

	setBBSelectedOptions(options = null) {
		localStorage.setItem(BB_SELECTED_OPTIONS, JSON.stringify(options))
	}

	handleVariant(variant) {
		return variant?.replace('\"', '')
	}

	handleUrlParams() {
		const urlParams = new URLSearchParams(window.location.search)
		const openCategoryParam = urlParams.get('openCategory')

		if (openCategoryParam) {
			const targetElement = [...document.querySelectorAll('.product-info')].find(
				el => el.textContent?.trim()?.toLowerCase() === openCategoryParam?.toLowerCase()
			)

			targetElement?.closest('li.grid')?.querySelector('a.li-a')?.click()
		}
	}

	getHideFlags({ product, settings, marketHandle }) {
		let hideShort = false
		let hideTall = false

		const hideShortMarkets = product?.hide_short_for_markets || []
		const hideTallMarkets = product?.hide_tall_for_markets || []

		const resolveMarketHandle = (market) => {
			const key = `${market.title.toLowerCase()}_market_handle`
			return settings[key]
		}

		for (const market of hideShortMarkets) {
			if (resolveMarketHandle(market) === marketHandle) {
				hideShort = true
				break
			}
		}

		for (const market of hideTallMarkets) {
			if (resolveMarketHandle(market) === marketHandle) {
				hideTall = true
				break
			}
		}

		return { hideShort, hideTall }
	}

	isMobile() {
		return window.innerWidth < 491
	}

	sizeSimplify(size = '') {
		if (!size) return

		const initSize = size.toLowerCase()

		switch (true) {
			case initSize === 'xsmall':
				return 'XS'

			case initSize === 'small':
				return 'S'

			case initSize === "medium":
				return 'M'

			case initSize === 'large':
				return 'L'

			case initSize === "xlarge":
				return 'XL'

			case initSize === "2xlarge":
				return '2XL'

			case initSize === "3xlarge":
				return '3XL'

			case initSize === "4xlarge":
				return '4XL'

			case initSize === "5xlarge":
				return '5XL'

			default:
				return size
		}
	}
}


const initBundleBuilderHandler = new BundleBuilderHandler()
initBundleBuilderHandler.init()
